import { H5, H6 } from "@sellar-io/components";
import dayjs from "dayjs";
import { ListElement } from "../../components";
import { DISTRIBUTION_PALLET_SHIPMENT_DETAILS } from "../../constants/routes";
import { useParamAsNumber } from "../../hooks/useParamAsNumber";
import { pluralize } from "@sellar-io/common";
import { SupplierPalletShipmentListResponseType } from "@sellar-io/api-v2/types";
import { shipmentStatus } from "./DistributionPalletShipmentListItem.shared";

export const DistributionPalletShipmentListItem = ({
  listItem,
}: {
  listItem: SupplierPalletShipmentListResponseType[number];
}) => {
  const palletShipmentId = useParamAsNumber(
    DISTRIBUTION_PALLET_SHIPMENT_DETAILS,
    "palletShipmentId",
    false,
  );

  const imageURl =
    "https://sellar.imgix.net/sellar-image-assets/sellar-logo-gradient.svg";

  const to = DISTRIBUTION_PALLET_SHIPMENT_DETAILS.href({
    palletShipmentId: listItem.id,
  });

  const selected = palletShipmentId === listItem.id;

  const finaliseDate = listItem.finalisedAt
    ? listItem.finalisedAt
    : listItem.expectedFinaliseDate;

  return (
    <ListElement promptText={""} to={to} selected={selected}>
      <img alt={"pallet-image"} src={imageURl} className={"h-12 w-12"} />
      <div className={"space-y-2"}>
        <div className="flex flex-col">
          <H5>
            {finaliseDate ? dayjs(finaliseDate).format("dddd DD MMMM") : "TBC"}{" "}
            - {listItem.distributionWarehouseName}
          </H5>
          <H6 className="text-zinc-500">
            {listItem.orderCount} {pluralize("order", listItem.orderCount)}
          </H6>
        </div>
        <div>
          <div className={"flex flex-wrap gap-2"}>
            {shipmentStatus(listItem.status)}
          </div>
        </div>
      </div>
    </ListElement>
  );
};
